import React from "react";

import { ScrollNavMenuBlock as BaseMenu } from "@thelabnyc/thelabui/src/components/ScrollNavMenuBlock";

import { TextLink } from "../Clickables";
import { Svg } from "../Svg";
import { ScrollNavMenuContainer } from "./ScrollNavMenuContainer";

import styles from "./index.module.scss";

export { ScrollNavMenuItemBlock } from "@thelabnyc/thelabui/src/components/ScrollNavMenuBlock";

type Props = Pick<React.ComponentProps<typeof BaseMenu>, "value"> & {
    title: string;
};

export function ScrollNavMenu({ value, title }: Props) {
    return (
        <div className={styles.root}>
            <BaseMenu
                value={value}
                classNames={styles}
                dependencies={{
                    ScrollNavMenuContainer: (args) => (
                        <ScrollNavMenuContainer {...args} title={title} />
                    ),
                }}
            />
            {value.right_cta && (
                <TextLink
                    className={styles.right}
                    simpleLink={value.right_cta}
                    icon={<Svg name="arrow" />}
                />
            )}
        </div>
    );
}
